import StatusCard from './StatusCard/StatusCard.vue';
import PointsCard from './PointsCard/PointsCard.vue';

export default {
  name: 'StatusPointsCard',
  components: {
    StatusCard,
    PointsCard
  },
  props: {
    wordings: {
      type: Object,
      default: () => {},
    },
    lang: {
      type: String,
      default: 'en',
    },
    statusInfo: {
      type: [Object, String],
      required: false,
      default: null
    },
  },
};
